import Vue from 'vue'
import 'core-js';

import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import Cookies from 'js-cookie';
import i18n from './lang'; // Internationalization
import '@/permission'; // permission control
import '@/icons'; // icon
import * as filters from './filters'; // global filters

// import axios from 'axios'
import '@/styles/index.scss';

// axios.defaults.baseURL = 'http://127.0.0.1:8000'

Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value),
});
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// verify roles
async function fetchUserPermissions() {
  try {
    // console.log('start Routes:', router.getRoutes());

    let {roles, permissions} = await store.dispatch('user/getInfo');
    const accessRoutes = await store.dispatch('permission/generateRoutes', { roles, permissions });
    // Thêm routes vào Vue Router
    accessRoutes.forEach(route => router.addRoute(route));

    // console.log('Routes đã thêm:', router.getRoutes());
  } catch (error) {
    console.error('Lỗi khi lấy quyền user hặc chưa đang nhập');
  }
}

fetchUserPermissions().then(() => {
  new Vue({
    router,
    store,
    i18n,

    render: h => h(App)
  }).$mount('#app')
});

